import * as tipos from '@/api/tipo'
import { convertSelect } from '../../../service/collection'

const state = {
  lista: [],
  listaSelect: []
}

const mutations = {
  SETPRODUTOSSELECT (state, payload) {
    state.listaSelect = convertSelect(payload)
  }
}

const actions = {
  async getTiposSelect ({ commit }, payload) {
    let data = await tipos.listSelect(payload)
    commit('SETPRODUTOSSELECT', data)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/tipo.js